import { render, staticRenderFns } from "./UltimasCompras.vue?vue&type=template&id=617dae40&scoped=true"
import script from "./UltimasCompras.vue?vue&type=script&lang=js"
export * from "./UltimasCompras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617dae40",
  null
  
)

export default component.exports